
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

import vSelect from "vue-select"

import api from "@/services/api"
import { Case } from "@/types/case"
const caseStore = namespace("cases")

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class CaseLinks extends Vue {
	@Prop()
	public currentCase: any;

	@Prop()
	canEditCurrentCase!: boolean;

	@caseStore.Action public linkCase!: (arg0: any) => void;

	@Getter("getCaseName") getCaseName!: string;
	@Getter("getRecordName") getRecordName!: string;

	public caseSearch: string = "";
	public searchResults: Case[] = [];
	public selectedCase: Case | null = null;

	public async fetchOptions (search: string, loading: (isLoading: boolean) => void) {
		if (search === "") {
			this.searchResults = []
		} else {
			loading(true)
			this.searchResults = await api.caseSearch(search)
			loading(false)
		}
	}

	public valueChanged (newValue: Case | null) {
		if (newValue) {
			if (this.currentCase.id) {
				api.linkCase(this.currentCase.id, newValue.id!)
			} else {
				if (!this.currentCase.links) {
					this.currentCase.links = []
				}

				this.currentCase.links.push({
					caseId: newValue.id!,
					caseNumber: newValue.caseNumber!,
					caseTitle: newValue.title
				})
			}

			this.selectedCase = null
		}
	}

	private caseAlreadyAdded (caseId: string) {
		if (!this.currentCase || !this.currentCase.links) {
			return false
		}

		return this.currentCase.links.some((link: any) => link.caseId === caseId)
	}
}
